import { Layout } from 'antd';
import React from 'react';
import { TAFooter } from '../components/footer/ta-footer';
import Navbar from '../components/navigation/navbar/navbar';
import authService from '../services/auth.service';

export const AuthLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<Layout className="min-vh-100">
			<Navbar isAuthenticated={authService.isAuthenticated()} />
			<Layout.Content className="d-flex">{children}</Layout.Content>
			<TAFooter />
		</Layout>
	);
};
